import React from 'react';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import lang from '../../../../constants/Languages.js';

import { getTextMetadataDataTransformed } from '../../../../scripts/TextMetadata.js';

const CardHeader = ({clang, cardName, parallelName, creationTime, id}) => {
    return (
        <div className="card__header">
            <h4 className="card__header-name">
                {cardName &&
                    <div className="card__header-title">
                        <span dangerouslySetInnerHTML={{__html: getTextMetadataDataTransformed(cardName)}}></span>
                        {cardName.transliterated ? <sup>t</sup> : false}
                    </div>}
                {parallelName &&
                    <div className="card__header-subtitle"><span dangerouslySetInnerHTML={{__html: parallelName.label}}></span>{parallelName.transliterated ? <sup>t</sup> : false}</div>}
            </h4>
            {(creationTime || id) &&
                <div className="card__meta-data">
                    {creationTime &&
                        <span className="card__meta-data__item">{lang[clang].item.release_date}: <strong>{creationTime}</strong></span>}
                    {id &&
                        <span className="card__meta-data__item">{lang[clang].item.cards.card_id}: <strong>{id}</strong></span>}
                </div>}
        </div>
    );
};

CardHeader.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(CardHeader);



// WEBPACK FOOTER //
// ./src/components/items/cards/common/CardHeader.js